import ApiCore from '../utilities/Core';

// Login API

const url = 'absence';
const plural = 'absence';
const single = 'absence';

export const apiAbsence = new ApiCore({
    getAll: false,
    getSingle: true,
    post: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
    plural: plural,
    single: single,
});
